/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect } from 'react';
import {
    Container, Card
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Button, Box, Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Service';
import authService from '../../../../utils/permissionAuth'
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import SearchNotFound from '../../../SearchNotFound';
import { CustomTable } from './CustomTable';

// function TablePaginationActions(props) {
//     const theme = useTheme();
//     const { count, page, rowsPerPage, onPageChange } = props;

//     const handleFirstPageButtonClick = (event) => {
//         onPageChange(event, 0);
//     };

//     const handleBackButtonClick = (event) => {
//         onPageChange(event, page - 1);
//     };

//     const handleNextButtonClick = (event) => {
//         onPageChange(event, page + 1);
//     };

//     const handleLastPageButtonClick = (event) => {
//         onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
//     };

//     return (
//         <Box sx={{ flexShrink: 0, ml: 2.5 }}>
//             <IconButton
//                 onClick={handleFirstPageButtonClick}
//                 disabled={page === 0}
//                 aria-label="first page"
//             >
//                 {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
//             </IconButton>
//             <IconButton
//                 onClick={handleBackButtonClick}
//                 disabled={page === 0}
//                 aria-label="previous page"
//             >
//                 {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
//             </IconButton>
//             <IconButton
//                 onClick={handleNextButtonClick}
//                 disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//                 aria-label="next page"
//             >
//                 {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
//             </IconButton>
//             <IconButton
//                 onClick={handleLastPageButtonClick}
//                 disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//                 aria-label="last page"
//             >
//                 {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
//             </IconButton>
//         </Box>
//     );
// }

// TablePaginationActions.propTypes = {
//     count: PropTypes.number.isRequired,
//     onPageChange: PropTypes.func.isRequired,
//     page: PropTypes.number.isRequired,
//     rowsPerPage: PropTypes.number.isRequired,
// };

const screenCode = 'PRODUCTLIFECYCLE';
export default function ProductLifeCycleListing(props) {
    const [productList, setProductList] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [productLifeCycleDetails, setProductLifeCycleDetails] = useState([]);
    const [newProductLifeCycleDetails, setNewProductLifeCycleDetails] = useState([]);
    let encrypted = "";
    const navigate = useNavigate();
    const [editProduct, setEditProduct] = useState(0);
    const [formData, setFormData] = useState({
        productCategoryID: "0",
        cropID: "0"
    });
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 5,
    });
    const productcatogerySearchSchema = Yup.object().shape({
        productCategoryID: Yup.number().min(1, 'Please Select Product Category').required('Product Category Required'),
        cropID: Yup.number()
    });
    const formik = useFormik({
        initialValues: {
            productCategoryID: formData.productCategoryID,
            cropID: formData.cropID
        },
        validationSchema: productcatogerySearchSchema,
        onSubmit: (values) => {
            trackPromise(GetProductLifeCycleDetailsByIDs(values.productCategoryID, values.cropID));
        },
    });
    const { errors, touched, handleSubmit, setValues, isSubmitting, getFieldProps, values } = formik;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [globalFilter, setGlobalFilter] = useState('');
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - productLifeCycleDetails.length) : 0;
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        setProductLifeCycleDetails([]);
        setNewProductLifeCycleDetails([]);
        const storedProductLifeCycleFormData = JSON.parse(sessionStorage.getItem('productLifeCycleFormData'));
        const storedPage = JSON.parse(sessionStorage.getItem('productLifeCyclePageData'));
        const storedSearch = JSON.parse(sessionStorage.getItem('productLifeCycleSearchData'));
        getPermission(storedProductLifeCycleFormData, storedPage, storedSearch);
        sessionStorage.removeItem('productLifeCycleFormData');
        sessionStorage.removeItem('productLifeCyclePageData');
        sessionStorage.removeItem('productLifeCycleSearchData');
    }, []);

    useEffect(() => {
        if (editProduct != 0) {
            EditProduct(editProduct)
        }
    }, [editProduct]);

    useEffect(() => {
        setValues({
            ...values,
            cropID: "0"
        })
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        trackPromise(GetProductDetails(formik.values.productCategoryID));
        setNewProductLifeCycleDetails([])
    }, [formik.values.productCategoryID]);

    async function getPermission(storedProductLifeCycleFormData, storedPage, storedSearch) {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(
            p => p.permissionCode == 'VIEWPRODUCTLIFECYCLE'
        );
        if (isAuthorized === undefined) {
            navigate('/404');
        }
        const isInitialLoading = storedProductLifeCycleFormData === null
        if (!isInitialLoading) {
            setValues({
                ...values,
                productCategoryID: parseInt(storedProductLifeCycleFormData.productCategoryID),
                cropID: parseInt(storedProductLifeCycleFormData.cropID)
            });
            trackPromise(GetProductLifeCycleDetailsByIDs(storedProductLifeCycleFormData.productCategoryID, storedProductLifeCycleFormData.cropID));
            if (storedPage !== null) {
                setPagination(storedPage);
            }
            if (storedSearch !== null) {
                setGlobalFilter(storedSearch);
            }
        }
        trackPromise(GetProductCategoties());
    }

    useEffect(() => {
        setNewProductLifeCycleDetails([])
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        setNewProductLifeCycleDetails([])
    }, [formik.values.cropID]);

    async function GetProductCategoties() {
        var res = await services.GetProductCategoties()
        if (res != null) {
            setProductcatogery(res);
        }
    }

    async function GetProductDetails(ProductCategoryID) {
        var res = await services.GetProductDetails(ProductCategoryID)
        if (formik.values.productCategoryID > 0) {
            if (res != null) {
                setProductList(res);
            }
        }
    }

    async function GetProductLifeCycleDetails() {
        var res = await services.GetProductLifeCycleDetails(formik.values.productCategoryID, formik.values.cropID)
        if (res != null) {
            setProductLifeCycleDetails(res);
        }
    }

    async function GetProductLifeCycleDetailsByIDs(productCategoryID, cropID) {
        var res = await services.GetProductLifeCycleDetailsByIDs(productCategoryID, cropID)
        if (res != null) {
            setNewProductLifeCycleDetails(res);
        }
    }

    async function EditProduct(productCategoryID) {
        sessionStorage.setItem('productLifeCycleFormData', JSON.stringify(values));
        sessionStorage.setItem('productLifeCyclePageData', JSON.stringify(pagination));
        sessionStorage.setItem('productLifeCycleSearchData', JSON.stringify(globalFilter));
        encrypted = AESEncryptionParam(productCategoryID.toString());
        navigate('/dashboard/productLifeCycle/addedit/' + encrypted)
    }

    function clearAll() {
        sessionStorage.removeItem('productLifeCycleFormData');
        sessionStorage.removeItem('productLifeCyclePageData');
        sessionStorage.removeItem('productLifeCycleSearchData');
        setValues({
            ...values,
            productCategoryID: 0,
            cropID: 0
        })
        setProductLifeCycleDetails([]);
        setNewProductLifeCycleDetails([]);
    }
    return (
        <>
            <LoadingComponent />
            <Page title="Product Life Cycle |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/productLifeCycle/addedit/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="Product Life Cycle"
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Product Category *"
                                        value={formik.values.productCategoryID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('productCategoryID')}
                                        error={Boolean(touched.productCategoryID && errors.productCategoryID)}
                                        helperText={touched.productCategoryID && errors.productCategoryID}
                                    >
                                        <MenuItem key={0} value={0}> Select Product Category</MenuItem>
                                        {productcatogery.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.productCategoryID} value={option.productCategoryID}>
                                                {option.productCategoryName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Crop "
                                        value={formik.values.cropID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('cropID')}
                                        error={Boolean(touched.cropID && errors.cropID)}
                                        helperText={touched.cropID && errors.cropID}
                                    >
                                        <MenuItem key={0} value={0}>All Crop</MenuItem>
                                        {productList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.productID} value={option.productID}>
                                                {option.productName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <Grid item md={8} xs={12}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color='error'
                                                onClick={() => clearAll()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Stack>
                                    </Grid>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {newProductLifeCycleDetails.length > 0 ?
                        <Card>
                            <CustomTable tableData={newProductLifeCycleDetails}
                                setEditProduct={setEditProduct}
                                pagination={pagination}
                                setPagination={setPagination}
                                globalFilter={globalFilter}
                                setGlobalFilter={setGlobalFilter} />
                        </Card>
                        : <SearchNotFound searchQuery="Product Life Cycle" />}
                </Container>
            </Page>
        </>
    );
}